import * as React from "react";
import { styled, Typography, CardActionArea, Card, Stack } from "@mui/material";

export type ExpertiseCardProps = {
  title: string;
  desc: string;
  icon: React.ReactNode;
  progressValue: number;
};

const ExpertiseCard: React.FC<ExpertiseCardProps> = (props) => {
  const { title, desc, icon, progressValue } = props;

  return (
    <StyledExpertiseCard>
      <CardActionArea>
        <StyledExpertiseIcon>{icon}</StyledExpertiseIcon>
        <Stack>
          <Typography variant="subtitle1" fontWeight={600} mb={0.5}>
            {title}
          </Typography>
          <Typography color="text.secondary" mb={1.5}>
            {desc}
          </Typography>
          <StyledProgress progressValue={progressValue} />
        </Stack>
      </CardActionArea>
    </StyledExpertiseCard>
  );
};

export default ExpertiseCard;

const StyledExpertiseCard = styled(Card)(({ theme }) => ({
  background: "none",
  boxShadow: "none",
  borderRadius: 10,

  ".MuiCardActionArea-root": {
    display: "flex",
    padding: theme.spacing(2),
  },

  "& + .MuiCard-root": {
    marginTop: theme.spacing(2.5),
  },

  ".MuiSvgIcon-root": {
    color: theme.palette.info.main,
  },
}));

const StyledExpertiseIcon = styled("div")(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: 33,
  background: theme.palette.backgroundAlpha.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  marginRight: theme.spacing(2.5),
  svg: {
    fontSize: 28,
  },
}));

const StyledProgress = styled("div", { shouldForwardProp: (prop) => prop !== "progressValue" })<{
  progressValue: number;
}>(({ theme, progressValue }) => ({
  position: "relative",
  height: 8,
  width: 162,
  background: theme.palette.backgroundAlpha.main,
  borderRadius: 10,
  overflow: "hidden",

  "&:after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: `${progressValue}%`,
    height: 8,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    background: "linear-gradient(90.05deg, #F7C035 0%, #F78635 96.97%)",
  },
}));
